document.addEventListener("DOMContentLoaded", function () {
  const lists = document.querySelectorAll(".filter-group-display__list");

  lists.forEach(list => {
    const items = list.querySelectorAll(".filter-group-display__list-item");
    const toggleBtn = list.nextElementSibling; 
    const maxVisible = 8;

    if (items.length > maxVisible) {
      // Ocultar los que exceden el límite
      items.forEach((item, index) => {
        if (index >= maxVisible) item.style.display = "none";
      });

      toggleBtn.addEventListener("click", function () {
        const isExpanded = toggleBtn.getAttribute("data-expanded") === "true";

        if (isExpanded) {
          items.forEach((item, index) => {
            if (index >= maxVisible) item.style.display = "none";
          });
          toggleBtn.textContent = "+ Ver más";
          toggleBtn.setAttribute("data-expanded", "false");
        } else {
          items.forEach(item => item.style.display = "list-item");
          toggleBtn.textContent = "- Ver menos";
          toggleBtn.setAttribute("data-expanded", "true");
        }
      });
    } else {
      toggleBtn.style.display = "none";
    }
  });
});